<template>
  <div class="u-select useral-custom-element-select" :class="classes" :tabindex="tabindex" v-click-outside="handleClickOutside">
<!--    <label v-if="label">{{ label }}</label>-->
    <div class="u-select-label-box" :class="[{'u-select-open': open && hasDropdownList, 'clickable': clickable, 'danger': danger, 'disabled': disabled || !hasDropdownList}, `u-select-position-${selectOpenPosition}`]">
      <div class="u-select-label-box-start"></div>
      <div v-if="label" class="u-select-label-box-center" :class="[labelPosition]">
        <span class="u-select-label text-subtitle" :class="[{'text-body-1': labelPosition === 'inside'}]">{{ label }}</span>
      </div>
      <div class="u-select-label-box-end"></div>
    </div>
    <div class="u-selected-item" :class="{ 'open': open, 'disabled': disabled || !hasDropdownList }" :style="styles" @click="setSelectOpenPosition">

      <div v-if="icon && searchable" class="input-icon">
        <custom-icon :icon="icon" color="dark-gray" height="1.5rem" width="1.5rem" />
      </div>

      <input v-if="searchable"
             type="text"
             class="useral-custom-element-input w-full"
             :autocomplete="'new-password'"
             :name="Math.random()"
             :placeholder="placeholder || ''"
             :disabled="disabled"
             @input="$emit('searched', $event)"
             v-model="search">

      <div class="u-selected-text-wrapper"
           v-else>
        <span class="u-selected-text" :class="[{[`type-${selected.styleType}`]: selected.styleType}, selected.color || '']">
        {{ typeof selected === 'string' ? JSON.parse(selected).label : selected.label }}
        </span>
      </div>
      <div v-if="searchable && search && !disabled"
           class="u-select-clear-search"
           @click="handleClearSelect">
        <custom-icon icon="xmark-icon" color="dark-gray" />
      </div>
      <div v-if="!disabled"
           class="u-select-arrow-icon">
        <custom-icon icon="chevron-down-icon" color="dark-gray" height="1.2rem" width="1.2rem" />
      </div>
    </div>

    <div v-show="hasDropdownList" class="u-select-items" :class="[{ 'u-select-hide': !open }, `position-${selectOpenPosition}`]" :style="{maxHeight: `${listMaxHeight}px`}">
      <template v-for="(option, i) of getSelectItems">
        <div
          :key="i"
          class="select-item"
          :class="{disabled: option.disabled}"
          @click="handleSelectOption(option)">
          <div class="select-item-text" :class="[{[`type-${option.styleType}`]: option.styleType}, option.color || '']">
            {{ typeof option === 'string' ? JSON.parse(option).label : option.label }}
            <span v-if="option.badge" class="select-badge" :class="option.badge.class">
              {{ option.badge.value }}
            </span>
          </div>
        </div>
      </template>
    </div>

    <div class="custom-select-overflow" v-if="open && hasBackdropOverflow" @click="open = false"></div>
  </div>
</template>

<script>
import CustomIcon from "../icon/customIcon.vue";

export default {
  name: 'customSelect',
  components: {CustomIcon},
  data () {
    return {
      firstVisit: true,
      firstVisitTimer: 0,
      selected: this.default ? this.default : this.getSelectItems && this.getSelectItems.length > 0 ? this.getSelectItems[0] : {label: '', value: ''},
      open: false,
      selectOpenPosition: 'bottom',
      search: '',
      listMaxHeight: 150
    }
  },
  model: {
    prop: 'default',
    event: 'input'
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: () => ''
    },
    labelPosition: {
      type: String,
      default: 'outline',
      validator (value) {
        return ['outline', 'outside'].includes(value)
      }
    },
    placeholder: {
      type: String,
      default: () => { return '' }
    },
    clickable: {
      type: Boolean,
      default: () => { return false }
    },
    setPageChange: {
      type: Boolean,
      default: () => { return true }
    },
    classes: {
      type: Array,
      default: () => []
    },

    styles: {
      type: String,
      default: () => ''
    },
    default: {
      type: [Object, String],
      default: () => { return {} }
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    icon: {
      type: String,
      default: ''
    },
    searchable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    },
    hasBackdropOverflow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getSelectItems () {
      return this.options.filter((option) => {
        return (!option.hasOwnProperty('show') || option.show) &&
          (!option.hasOwnProperty('showOption') || option.showOption) && this.selected.value !== option.value
      })
    },
    hasDropdownList () {
      return this.getSelectItems.length > 0
    }
  },
  mounted () {
    // this.$emit("input", this.selected);
    this.search = this.selected.label === '-' ? '' : this.selected.label
    if (this.default) this.search = this.default.label === '-' ? '' : this.default.label
  },
  methods: {
    setSelectOpenPosition () {
      const modalEl = this.$el.closest('.prompt-content')
      let spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom
      let spaceTop = this.$el.getBoundingClientRect().top
      if (modalEl) {
        const modalRect = modalEl.getBoundingClientRect()
        const elementRect = this.$el.getBoundingClientRect()

        spaceBelow = modalRect.bottom - elementRect.bottom
        spaceTop = elementRect.top - modalRect.top
      }
      if (spaceBelow > 100) {
        this.selectOpenPosition = 'bottom'
        this.listMaxHeight = Math.min(spaceBelow - 20, 250)
      } else {
        this.selectOpenPosition = 'top'
        this.listMaxHeight = Math.min(spaceTop - 20, 250)
      }
      if (!this.disabled) {
        this.open = !this.open
      }
    },
    handleClickOutside () {
      if (this.open) {
        this.open = false
      }
    },
    handleSelectOption (option) {
      if (!option.disabled) {
        this.selected = option
        this.open = false
        if (this.setPageChange) {
          this.$store.dispatch('setPageChanges')
        }
        this.$emit('input', option)
        this.$emit('suggest:selected', option)
        this.search = option.label
      }
    },
    handleClearSelect () {
      this.search = ''
      this.selected = {
        value: '',
        label: ''
      }
    }
  },
  watch: {
    default: {
      handler () {
        if (this.default && this.default.label !== '') {
          this.selected = this.default

          if (this.searchable) {
            this.search = this.default.label === '-' ? '' : this.default.label
          }
        }
      },
      deep: true
    },
    search: {
      handler (val) {
        if (this.searchable) {
          clearTimeout(this.firstVisitTimer)
          this.firstVisitTimer = setTimeout(() => {
            this.firstVisit = false
          }, 500)

          if (!this.firstVisit) {
            // this.open = true

            this.options.forEach((option) => {
              option.showOption = option.label.toString().toLowerCase().indexOf(val.toLowerCase()) !== -1
            })
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
</style>
